import { Component, input, output, InputSignal, OutputEmitterRef, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

@Component({
    selector: 'adm4-dialog-title',
    imports: [MatIcon, MatIconButton],
    template: `
  <span class="dialog-title">{{title()}}</span>
  @if (showClose()) {
    <button type="button" mat-icon-button aria-label="close" (click)='close.emit()'>
      <mat-icon>clear</mat-icon>
    </button>
  }
  `,
    styleUrl: './dialog-title.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogTitleComponent {

  public readonly title: InputSignal<string> = input.required<string>();
  public readonly showClose: InputSignal<boolean | undefined> = input<boolean>();

  public readonly close: OutputEmitterRef<void> = output();
}
